<template>
  <div id="hrms-calendar-work-time">
    <div class="col-sm-6">
      <hrms-calendar-year :selectingYear="selectingYear"
                          :setSelectYear="setSelectYear" />
      <!-- Section Month -->
      <ul class="month">
        <li v-for="index in 12" :id="index"
            :class="{ 'current-month' : index == selectingMonth }"
            v-on:click="setSelectMonth(index)">{{ month[app.nowLang][index-1].short }}</li>
      </ul>

      <!-- Section Weekdays -->
      <div class="table-calendar">
        <table class="table table-bordered" align="center" id="calendar-date">
          <thead class="weekdays">
            <tr>
              <th v-for="index_day in 7"
                  :id="index_day">
                  {{ days[app.nowLang][index_day - 1] }}
              </th>
            </tr>
          </thead>
          <!-- Section days -->
          <tbody class="days">
            <template v-for="week in totalWeek">
              <hrms-week-row :arrWeek="calArrWeek(week)"
                        :setSelectDate="setSelectDate"
                        :checkCurrentDay="checkCurrentDay"
                        :checkSelectedDay="checkSelectedDay"
                        :selectedMonth="selectedMonth"
                        :typwork="typwork" />
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-sm-6 carlendar-detail-mb">
      <hrms-calendar-detail :nowLang="app.nowLang" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/hrmsCalendarWorkTime/mutation-types'
import moment from 'moment'
import _ from 'lodash'
import hrmsWeekRow from 'components/hrmsCalendarWorkTime/hrmsWeekRow'
import hrmsCalendarYear from 'components/hrmsCalendarWorkTime/hrmsCalendarYear'
import hrmsCalendarDetail from 'components/hrmsCalendarWorkTime/hrmsCalendarDetail'

const label = require('src/../config/label')
const defaultDate = {
  currentYear: new Date().getFullYear(),
  currentMonth: new Date().getMonth() + 1,
  currentDate: new Date().getDate(),
  currentDay: new Date().getDay()
}

export default {
  name: 'hrms-calendar-work-time',
  data () {
    return {
      app: this.$root.$children[0],
      currentYear: defaultDate.currentYear,
      currentMonth: defaultDate.currentMonth,
      currentDate: defaultDate.currentDate,
      currentDay: defaultDate.currentDay,
      selectingYear: defaultDate.currentYear,
      selectingMonth: defaultDate.currentMonth,
      selectedYear: defaultDate.currentYear,
      selectedMonth: defaultDate.currentMonth,
      selectedDate: defaultDate.currentDate,
      selectedDay: defaultDate.currentDay,
      days: label.days,
      month: label.month
    }
  },
  props: {
    codempid: {
      type: String,
      default: '53100'
    }
  },
  created () {
    this.receivedTypwork({ codempid: this.codempid, year: this.selectingYear })
  },
  watch: {
    codempid () {
      this.receivedTypwork({ codempid: this.codempid, year: this.selectingYear })
    }
  },
  computed: {
    totalWeek () {
      return Math.ceil((this.firstDate + this.sumDayInMonth) / 7)
    },
    firstDate () {
      return Number(moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01')).format('e'))
    },
    sumDayInMonth () {
      return moment(moment().format(this.selectingYear + '-' + _.padStart(this.selectingMonth, 2, '0') + '-01')).daysInMonth()
    },
    ...mapGetters({
      typwork: types.GET_HRMS_CALENDAR_WORKTIME_TYPWORK
    })
  },
  methods: {
    checkCurrentDay (day) {
      return (this.currentMonth === this.selectingMonth &&
             this.currentYear === this.selectingYear &&
             this.currentDate === day)
    },
    checkSelectedDay (day) {
      return (this.selectedMonth === this.selectingMonth &&
             this.selectedYear === this.selectingYear &&
             this.selectedDate === day)
    },
    calArrWeek (week) {
      var dayStartInRow = 1 + (week - 1) * 7
      if (week > 1) {
        dayStartInRow = dayStartInRow - this.firstDate
      }
      var arrWeek = []
      for (var i = 1; i <= 7; i++) {
        if (week === 1 && i <= this.firstDate) {
          for (var j = 1; j <= this.firstDate; j++) {
            arrWeek.push('')
            i++
          }
        }

        if (dayStartInRow <= this.sumDayInMonth) {
          arrWeek.push(dayStartInRow)
          dayStartInRow++
        } else {
          arrWeek.push('')
        }
      }
      return arrWeek
    },
    setSelectYear (year) {
      this.selectingYear = this.selectingYear + year
      this.receivedTypwork({ codempid: this.codempid, year: this.selectingYear })
    },
    setSelectMonth (month) {
      this.selectingMonth = month
      if (!this.calendarSwitch) { // monthMode
        this.selectedYear = this.selectingYear
        this.selectedMonth = month
      }
    },
    setSelectDate (objDate) {
      this.selectedYear = this.selectingYear
      this.selectedMonth = this.selectingMonth
      this.selectedDate = objDate.date
      this.selectedDay = objDate.day
    },
    ...mapActions({
      receivedTypwork: types.RECEIVED_HRMS_CALENDAR_WORKTIME_TYPWORK
    })
  },
  components: {
    hrmsWeekRow,
    hrmsCalendarYear,
    hrmsCalendarDetail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?e89f68ca